import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40530432"),n=n(),_popScopeId(),n)
const _hoisted_1 = { temp: "f" }
const _hoisted_2 = { class: "detail-head flex" }
const _hoisted_3 = { class: "detail-item" }
const _hoisted_4 = { class: "detail-item" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "detail-item" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "detail-item" }
const _hoisted_11 = {
  key: 0,
  class: "detail-item"
}
const _hoisted_12 = { class: "detail-item" }
const _hoisted_13 = {
  key: 0,
  class: "detail-item bot-border"
}
const _hoisted_14 = { class: "detail-item" }
const _hoisted_15 = { class: "detail-item" }
const _hoisted_16 = { class: "detail-item" }
const _hoisted_17 = { class: "table" }
const _hoisted_18 = { class: "table-thead" }
const _hoisted_19 = { class: "table-body" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["src"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "detail-item" }
const _hoisted_25 = { class: "detail-item" }
const _hoisted_26 = { class: "detail-item" }
const _hoisted_27 = { class: "table" }
const _hoisted_28 = { class: "table-thead" }
const _hoisted_29 = { class: "table-body" }
const _hoisted_30 = ["src"]

import { t } from '@/plugins/i18n'
import { ref, reactive, computed } from 'vue'
import { getJapanTime } from '@/util/common'
import { formatPrice, plusPrice, reducePrice, setFixed2 } from './data'
import { BASE_IMAGE } from '@/common/baseImage'
import { isMultiStore, isJA } from '@/store'
import { showCurrentUnit } from '@/util/useYan'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowName: {
    type: String,
    default: ''
  },
  rowItemDetail: {
    type: Object,
    default: () => ({})
  },
  type: {
    type: Number,
    default: 1
  }
},
  setup(__props) {

const props = __props
const sum = (arr: any[] | null) => {
  if (!arr) return 0
  return arr.reduce((total, v) => total + (v.totalPrice ?? 0), 0)
}

const sumqty = (arr: any[] | null) => {
  if (!arr) return 0
  return arr.reduce((total, v) => total + (v.quantity ?? 0), 0)
}


// 当前币种对应的单位
const currencyCodeUnit = computed(() => {
  return showCurrentUnit(isMultiStore() && props.rowItemDetail?.currencyCode === 'KRW')
})
const productColumns = [
  { prop: 'productImg', label: t('商品图片') },
  { prop: 'productSku', label: t('平台商品SKU') },
  { prop: 'customerProductSku', label: t('客户商品SKU') },
  { prop: 'productTitle', label: t('商品名称') },
  { prop: 'actualProductSellPrice', label: t('参考单价'), isNeedUnit: true },
  { prop: 'orderQuantity', label: t('下单数量') },
  { prop: 'quantity', label: props.type === 1 ? t('冻结数量') : t('解冻数量') },
  { prop: 'totalPrice', label: props.type === 1 ? t('冻结总价') : t('解冻总价'), isNeedUnit: true }
]

const productColumns2 = [
  { prop: 'productImg', label: t('商品图片') },
  { prop: 'productSku', label: t('平台商品SKU') },
  { prop: 'customerProductSku', label: t('客户商品SKU') },
  { prop: 'productTitle', label: t('商品名称') },
  { prop: 'cost', label: t('参考单价'), isNeedUnit: true },
  { prop: 'orderQuantity', label: t('下单数量') },
  { prop: 'quantity', label: props.type === 1 ? t('冻结数量') : t('解冻数量') },
  { prop: 'totalPrice', label: props.type === 1 ? t('冻结总价') : t('解冻总价'), isNeedUnit: true }
]
/** 获取图片 */
const getImage = (value: string) => {
  return value?.split(',')?.[0] || BASE_IMAGE
}

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('THE CKB订单编号')) + "：", 1),
        _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.platformOrderNo ?? ''), 1)
      ]),
      _createElementVNode("p", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('客户订单编号')) + "：", 1),
        (__props.rowItemDetail?.customerOrderNo)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.rowItemDetail?.customerOrderNo), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.rowItemDetail?.customerBill?.customerOrderNo ?? '-'), 1))
      ]),
      _createElementVNode("p", _hoisted_7, [
        (__props.rowItemDetail.platformOrderProductSettleDetail?.needStagesPayStatus === 1 && __props.rowItemDetail.fundFlowType === 8)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(t)('本期冻结总价')), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(__props.type === 1 ? _unref(t)('冻结总价') : _unref(t)('解冻总价')) + "：", 1)),
        _createElementVNode("span", null, _toDisplayString(__props.type === 1 ? _unref(reducePrice)(__props.rowItemDetail?.changeAmount) : _unref(plusPrice)(__props.rowItemDetail?.changeAmount)) + _toDisplayString(_unref(currencyCodeUnit)), 1)
      ]),
      _createElementVNode("p", _hoisted_10, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('可用余额')) + "：", 1),
        _createElementVNode("span", null, _toDisplayString(_unref(formatPrice)(__props.rowItemDetail?.afterAvailableAmount)) + _toDisplayString(_unref(currencyCodeUnit)), 1)
      ]),
      (__props.rowItemDetail.fundFlowNo)
        ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('流水号')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.fundFlowNo), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_12, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('日期')) + "：", 1),
        _createElementVNode("span", null, _toDisplayString(_unref(getJapanTime)(__props.rowItemDetail?.createTime)), 1)
      ])
    ]),
    (__props.rowItemDetail.platformOrderProductSettleDetail?.needStagesPayStatus === 1 && __props.rowItemDetail.fundFlowType === 8)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('订单应冻结金额')), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_scrollbar, { height: "500px" }, {
      default: _withCtx(() => [
        (__props.rowItemDetail.platformOrderProductSettleDetail?.itemSettleList)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("p", _hoisted_14, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('费用类型')) + "：", 1),
                _createElementVNode("span", null, [
                  (__props.type === 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(__props.rowItemDetail.platformOrderProductSettleDetail?.itemSettleList?.[0]?.platformOrderItemSettleType === 4
                ?
                _unref(t)('重拍冻结商品代金') : _unref(t)('冻结商品代金')), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(t)('解冻商品代金')), 1)
                      ], 64))
                ])
              ]),
              _createElementVNode("p", _hoisted_15, [
                _createElementVNode("span", null, _toDisplayString(__props.type === 1 ? _unref(t)('冻结总数量') : _unref(t)('解冻总数量')) + "：", 1),
                _createElementVNode("span", null, _toDisplayString(sumqty(__props.rowItemDetail.platformOrderProductSettleDetail?.itemSettleList)), 1)
              ]),
              _createElementVNode("p", _hoisted_16, [
                _createElementVNode("span", null, _toDisplayString(__props.type === 1 ? _unref(t)('冻结总价') : _unref(t)('解冻总价')) + "：", 1),
                _createElementVNode("span", null, _toDisplayString(__props.type === 1
              ? _unref(reducePrice)(_unref(setFixed2)(sum(__props.rowItemDetail.platformOrderProductSettleDetail?.itemSettleList)))
              : _unref(plusPrice)(_unref(setFixed2)(sum(__props.rowItemDetail.platformOrderProductSettleDetail?.itemSettleList)))) + " " + _toDisplayString(_unref(currencyCodeUnit)), 1)
              ]),
              _createElementVNode("table", _hoisted_17, [
                _createElementVNode("thead", _hoisted_18, [
                  _createElementVNode("tr", null, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(productColumns, (item) => {
                      return _createElementVNode("th", {
                        key: item.prop,
                        width: "200"
                      }, _toDisplayString(item.label), 1)
                    }), 64))
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.rowItemDetail.platformOrderProductSettleDetail?.itemSettleList || []), (row) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: row.productSku
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(productColumns, (v) => {
                        return _createElementVNode("td", {
                          key: v.prop
                        }, [
                          (v.prop === 'productImg')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("img", {
                                  referrerPolicy: "no-referrer",
                                  src: getImage(row[v.prop]),
                                  alt: "",
                                  style: {"width":"60px"}
                                }, null, 8, _hoisted_21)
                              ]))
                            : (v.isNeedUnit && _unref(isJA)())
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(row[v.prop]) + _toDisplayString(_unref(currencyCodeUnit)), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(row[v.prop]), 1))
                        ])
                      }), 64))
                    ]))
                  }), 128))
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.rowItemDetail.platformOrderProductSettleDetail?.additionSettleList || []), (w) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: w.additionCode
          }, [
            _createElementVNode("p", _hoisted_24, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('费用类型')) + "：", 1),
              _createElementVNode("span", null, _toDisplayString(__props.rowName) + "(" + _toDisplayString(w.additionNameJp) + ")", 1)
            ]),
            _createElementVNode("p", _hoisted_25, [
              _createElementVNode("span", null, _toDisplayString(__props.type === 1 ? _unref(t)('冻结总数量') : _unref(t)('解冻总数量')) + "：", 1),
              _createElementVNode("span", null, _toDisplayString(_unref(setFixed2)(w.itemAdditionSettleList.reduce((total, v) => total + (v.quantity ?? 0), 0))), 1)
            ]),
            _createElementVNode("p", _hoisted_26, [
              _createElementVNode("span", null, _toDisplayString(__props.type === 1 ? _unref(t)('冻结总价') : _unref(t)('解冻总价')) + "：", 1),
              _createElementVNode("span", null, _toDisplayString(__props.type === 1
              ? _unref(reducePrice)(_unref(setFixed2)(w.itemAdditionSettleList.reduce((total, v) => total + (v.totalPrice ??
                0), 0)))
              : _unref(plusPrice)(_unref(setFixed2)(w.itemAdditionSettleList.reduce((total, v) => total + (v.totalPrice ??
                0), 0)))) + " " + _toDisplayString(_unref(currencyCodeUnit)), 1)
            ]),
            _createElementVNode("table", _hoisted_27, [
              _createElementVNode("thead", _hoisted_28, [
                _createElementVNode("tr", null, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(productColumns2, (item) => {
                    return _createElementVNode("th", {
                      key: item.prop,
                      width: "200"
                    }, _toDisplayString(item.label), 1)
                  }), 64))
                ])
              ]),
              _createElementVNode("tbody", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((w.itemAdditionSettleList || []), (row) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: row.productSku
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(productColumns2, (v) => {
                      return _createElementVNode("td", {
                        key: v.prop
                      }, [
                        (v.prop === 'productImg')
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              referrerPolicy: "no-referrer",
                              src: getImage(row[v.prop]),
                              alt: "",
                              style: {"width":"60px"}
                            }, null, 8, _hoisted_30))
                          : (v.isNeedUnit && _unref(isJA)())
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(row[v.prop]) + _toDisplayString(_unref(currencyCodeUnit)), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(row[v.prop]), 1)
                              ], 64))
                      ])
                    }), 64))
                  ]))
                }), 128))
              ])
            ])
          ], 64))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})